import { render, staticRenderFns } from "./FiltersContainer.vue?vue&type=template&id=4fb1a4e2&scoped=true"
import script from "./FiltersContainer.ts?vue&type=script&lang=ts&external"
export * from "./FiltersContainer.ts?vue&type=script&lang=ts&external"
import style0 from "./FiltersContainer.vue?vue&type=style&index=0&id=4fb1a4e2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb1a4e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fb1a4e2')) {
      api.createRecord('4fb1a4e2', component.options)
    } else {
      api.reload('4fb1a4e2', component.options)
    }
    module.hot.accept("./FiltersContainer.vue?vue&type=template&id=4fb1a4e2&scoped=true", function () {
      api.rerender('4fb1a4e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Reports/components/historical/FiltersContainer/FiltersContainer.vue"
export default component.exports